const { instance } = require('./url')
const { ObjectToParams } = require('./urlparser')
const {JustDate} = require('../JustDate')
const {Quote} = require('../Quote')

async function getQuote(id) {
    return await instance.get('/quote/' + id)
}

async function getQuotes(searchModel) {
    return await instance.get(
        '/quote' + ObjectToParams(searchModel))
}

async function queryQuote(searchModel) {
    return await instance.post(
        '/quote/query',
        {
            'search': searchModel,
        },
    ).then(
        (success) => {
            return success.data.quotes.map((quote) => {
                return Quote.from(quote)
            })
        },
    )
}

async function createQuote(quote) {
    return await instance.post('/quote', {
        'quote': quote
    })
}

async function updateQuote(quote) {
    return await instance.put('/quote/' + quote.id, {
        'quote': quote
    })
}

async function updateBacklogPage(quote) {
    const smaller_quote = ((
        { id, project_manager, is_thermoformed, materials, project_manager_comment}
    ) => (
        { id, project_manager, is_thermoformed, materials, project_manager_comment}
    ))(quote)
    return await instance.put('/quote/' + smaller_quote.id, {
        'quote': smaller_quote
    })
}

async function queryByBacklog(backlogsRequired, backlogsRequiredToday, latestBacklogs, date) {
    return await instance.post('/quote/queryByBacklog', {
        'backlogs_required': backlogsRequired,
        'backlogs_required_today': backlogsRequiredToday,
        'latest_backlogs': latestBacklogs,
        'date': date || new JustDate(),
    })
}

async function deleteQuote(quoteId) {
    return await instance.delete('/quote/' + quoteId)
}

async function getCustomerNames(customerName) {
    return await instance.get('/quote/customerName/' + customerName)
}

async function getContactInfo(whereVariable, customerName, firstName) {
    return await instance.post('/quote/contactInformation', {
        'where_variable': whereVariable,
        'customer_name': customerName,
        'first_name': firstName,
    })
}

async function getTeamNames() {
    return await instance.get('/quote/team_names')
}

// Targeted write - the server's updateQuote whitelist only touches fields
// that are present, so this cannot clobber a concurrent edit elsewhere on
// the quote.
async function updateTeamName(quoteId, teamName) {
    return await instance.put('/quote/' + quoteId, {
        'quote': {
            'team_name': teamName,
        },
    })
}

async function updateIsShipped(quoteId, isShipped, shippedDate) {
    return await instance.put('/quote/' + quoteId, {
        'quote': {
            'is_shipped': isShipped,
            'shipped_date': isShipped
                ? shippedDate
                : null,
        },
    })
}

async function getAsanteContactInformation(firstName) {
    return await instance.get('/quote/asanteContactInformation/' + firstName)
}

async function getTypes() {
    return await instance.get('/quote/signtypes')
}

async function suggestQuoteFromFiles(quoteId) {
    return await instance.post('/quote/' + quoteId + '/suggestFromFiles')
}

export {
    getQuotes,
    getQuote,
    queryQuote,
    createQuote,
    updateQuote,
    updateBacklogPage,
    getTeamNames,
    updateTeamName,
    deleteQuote,
    getCustomerNames,
    getContactInfo,
    updateIsShipped,
    getAsanteContactInformation,
    getTypes,
    queryByBacklog,
    suggestQuoteFromFiles,
}

